import { render, staticRenderFns } from "./issued-invoices-details-page.vue?vue&type=template&id=5d29545a&scoped=true"
import script from "./issued-invoices-details-page.vue?vue&type=script&lang=js"
export * from "./issued-invoices-details-page.vue?vue&type=script&lang=js"
import style0 from "./issued-invoices-details-page.vue?vue&type=style&index=0&id=5d29545a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d29545a",
  null
  
)

export default component.exports